<template>
  <div class="page-table projeTanim  mainDiv mb-30" id="affix-container">
    <div class="animated fadeInUp card-base baslikBg">Yatırım Tanımla</div>
    <el-row :gutter="10" v-loading="loading || ilLoading || ilceLoading"
            :element-loading-text='loading ? "Veriler Getiriliyor, Lütfen Bekleyiniz..." : ilLoading ? "İl Listesi Getiriliyor. Lütfen Bekleyiniz." : "İlce Listesi Getiriliyor. Lütfen Bekleyiniz."'
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-form status-icon :model="projeForm" :rules="rulesProje" ref="projeForm" class="demo-ruleForm">
        <el-col :lg="18" :md="18" :sm="24" :xs="24">
          <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft pb-10 pt-10">
            <el-row>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Yatırımcı Adı" prop="musteriID">
                  <el-select style="width: 100%" size="small" auto-complete="off"
                             v-model="projeForm.musteriID" placeholder="Yatırımcı Seçiniz" filterable
                             :filter-methos="filterMethod">
                    <el-option v-for="item in musteriler" aria-autocomplete="none" :key="item.musteriID"
                               :label="item.musteriAdi" :value="item.musteriID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Proje Adı" prop="projeBaslik">
                  <el-input auto-complete="off" size="small" v-model="projeForm.projeBaslik"
                            :placeholder="'Proje Adı Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Yatırım Tutarı" prop="yatirimTutari">
                  <el-input auto-complete="off" size="small" @input="formatAlan"
                            v-model="projeForm.yatirimTutari" :placeholder="'Yatırım Tutarı'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="İstihdam Sayısı" prop="istihdamSayisi">
                  <el-input auto-complete="off" size="small" @input="formatAlan"
                            v-model="projeForm.istihdamSayisi"
                            :placeholder="'İstihdam Sayısı Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Alan" prop="alan">
                  <el-input auto-complete="off" size="small" @input="formatAlan" v-model="projeForm.alan"
                            :placeholder="'Alan Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Ada" prop="ada">
                  <el-input auto-complete="off" size="small" v-mask="'##############'"
                            v-model="projeForm.ada" :placeholder="'Ada Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Parsel" prop="parsel">
                  <el-input auto-complete="off" size="small" @input="validateParsel"
                            v-model="projeForm.parsel" :placeholder="'Parsel Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--
            <el-row>
                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                    <el-form-item label="Ülke" prop="ulkeID">
                        <el-select style="width: 100%" size="small" v-model="projeForm.ulkeID"
                            @change="getIlListesi" placeholder="Ülke Seçiniz" filterable
                            :filter-methos="filterMethod">
                            <el-option v-for="item in ulkeSehir" aria-autocomplete="none" :key="item.ulkeID" :label="item.ulkeAdi"
                                :value="item.ulkeID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                    <el-form-item label="İl" prop="ilID">
                        <el-select style="width: 100%" size="small" v-model="projeForm.ilID"
                            @change="getIlceListesi" placeholder="İl Seçiniz" filterable
                            :filter-methos="filterMethod">
                            <el-option v-for="item in iller" aria-autocomplete="none" :key="item.ilID" :label="item.ilBaslik"
                                :value="item.ilID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                    <el-form-item label="İlçe" prop="ilceID">
                        <el-select style="width: 100%" size="small" v-model="projeForm.ilceID"
                            placeholder="İlçe Seçiniz" filterable :filter-methos="filterMethod">
                            <el-option v-for="item in ilceler" aria-autocomplete="none" :key="item.ilceID" :label="item.ilceBaslik"
                                :value="item.ilceID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            -->
            <el-row>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Adres" prop="adresBaslik">
                  <el-input type="textarea" auto-complete="off" :autosize="{ minRows: 2, maxRows: 4 }"
                            placeholder="Adres Giriniz" v-model="projeForm.adresBaslik">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Not" prop="not">
                  <el-input type="textarea" auto-complete="off" :autosize="{ minRows: 2 }"
                            placeholder="Not" v-model="projeForm.not">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :lg="6" :md="6" :sm="24" :xs="24">
          <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
            <el-collapse-item class="card-shadow--medium pt-10" name="8"
                              :title='$t("src.views.apps.genel.durum")'>
              <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                  <el-form-item prop="durum">
                    <el-select size="small" :disabled="disabled" v-model="projeForm.durum"
                               :placeholder='$t("src.views.apps.messages.addBultenTitle")' style="width: 100%">
                      <el-option value="1" label='Aktif'></el-option>
                      <el-option value="0" label='Pasif'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-button size="mini" v-on:click="projeEkle('projeForm', projeForm.durum)" class="onayBtn"
                           type="primary">
                  <label>Kaydet</label>
                </el-button>
                &nbsp;
                <el-popover placement="bottom" width="300" v-model="visibleSil">
                  <p>{{ $t('src.views.apps.messages.clearFormAlert') }}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="primary" @click="resetForm('projeForm')">
                      {{ $t('src.views.apps.genel.yes') }}
                    </el-button>
                    <el-button size="mini" @click="visibleSil = false;">
                      {{ $t('src.views.apps.genel.no') }}
                    </el-button>
                  </div>
                  <el-button size="mini" slot="reference">
                    {{ $t('src.views.apps.genel.temizle') }}
                  </el-button>
                </el-popover>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col :lg="18" :md="18" :sm="24" :xs="24" class="yatirim-guncelle-tarih-col yatirim-tarihler-ust-col">
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card" :style="{border : customError.tebligat ?'3px solid red' : 'none'}">
              <div class="top-row-line-space"/>
              <h4>Yönetim Tarihi</h4>
              <el-tooltip class="item" effect="dark"
                          content="Tebligat tarihi zorunludur ve daha sonra revizyon edilemez !" placement="top">
                <i class="mdi mdi-information mdi-18px information-icon"></i>
              </el-tooltip>
              <el-form-item style="margin-bottom: 15px" prop="yonetimTarih">
                <el-date-picker @change="setCustomChange($event,'yonetim',true)" :clearable="false"
                                v-model="projeForm.tarihler.yonetimTarihi" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="datePickerOptions('yonetim')">
                </el-date-picker>
              </el-form-item>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card" :style="{border : customError.tebligat ?'3px solid red' : 'none'}">
              <div class="top-row-line-space"/>
              <h4>Tebligat Tarihi</h4>
              <el-tooltip class="item" effect="dark"
                          content="Tebligat tarihi zorunludur ve daha sonra revizyon edilemez !" placement="top">
                <i class="mdi mdi-information mdi-18px information-icon"></i>
              </el-tooltip>
              <el-form-item style="margin-bottom: 15px" prop="tebligatTarih">
                <el-date-picker @change="setCustomChange($event,'tebligat',true)" :clearable="false"
                                v-model="projeForm.tarihler.tebligatTarihi" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="datePickerOptions('tebligat')">
                </el-date-picker>
              </el-form-item>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card" :style="{border : customError.noter ?'3px solid red' : 'none'}">
              <div class="top-row-line-space"/>
              <h4>Noter Tarihi</h4>
              <el-tooltip class="item" effect="dark"
                          content="Noter tarihi zorunludur ve daha sonra revizyon edilemez !" placement="top">
                <i class="mdi mdi-information mdi-18px information-icon"></i>
              </el-tooltip>
              <el-form-item style="margin-bottom: 15px" prop="noterTarih">
                <el-date-picker @change="setCustomChange($event,'noter',true)" :clearable="false"
                                v-model="projeForm.tarihler.noterTarihi" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="datePickerOptions('noter')">
                </el-date-picker>
              </el-form-item>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card">
              <div class="top-row-line-space"/>
              <h4>Arsa Tahsis Tarihi</h4>
              <el-form-item style="margin-bottom: 15px">
                <el-date-picker @change="setCustomChange($event,'arsaTahsis')"
                                v-model="projeForm.tarihler.arsaTahsisTarihi" size="small" class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="datePickerOptions('arsaTahsis')">
                </el-date-picker>
              </el-form-item>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card">
              <div class="top-row-line-space"/>
              <h4>Yapı Ruhsat Tarihi</h4>
              <el-form-item style="margin-bottom: 15px">
                <el-date-picker @change="setCustomChange($event,'yapiRuhsat')"
                                v-model="projeForm.tarihler.yapiRuhsatTarihi" size="small" class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="datePickerOptions('yapiRuhsat')">
                </el-date-picker>
              </el-form-item>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12" style="padding-right: 0;">
            <el-card class="arsa-tarih-card">
              <div class="top-row-line-space"/>
              <h4>İş Yeri Açma Ruhsat Tarihi</h4>
              <el-form-item style="margin-bottom: 15px">
                <el-date-picker @change="setCustomChange($event,'isYeriAcmaRuhsat')"
                                v-model="projeForm.tarihler.isYeriAcmaRuhsatTarihi" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd"
                                :picker-options="datePickerOptions('isYeriAcma')">
                </el-date-picker>
              </el-form-item>
            </el-card>
          </el-col>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
import musteriService from '../../../WSProvider/MusteriService'
import projeService from '../../../WSProvider/ProjeService'
import notification from '../../../notification'
import functions from '../../../functions'
import EventBus from '@/components/event-bus'

var moment = require('moment');
let time = moment().format('YYYY-MM-DD');

export default {
  name: "YatirimTanimla",
  components: {},
  created() {
    this.checkDevice();
  },
  mounted() {
    const self = this;
    window.addEventListener('resize', this.checkDevice);
    this.getMusteriListesi();
    // this.getUlkeSehirListesi();
    // this.getSozlesmeListesi();
    this.sozlesmeList.forEach(el => {
      el.secili = false;
      el.baslamaTarihi = '';
      el.isTeslimTarihi = '';
    })

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  data() {
    return {
      isDesktop: false,
      grupSwitchState: false,
      dialogVisibleYonetici: false,
      secim: false,
      kontrol: false,
      musteriler: [],
      ulkeler: [],
      ulkeSehir: [],
      iller: [],
      ilceler: [],
      sozlesmeList: [],
      gruplanmisSozlesmeler: [],
      sozlesme: "",
      baslamaTarihi: "",
      bitisTarisi: "",
      tumunuSec: false,
      cakisma: "",
      cakismaIDs: [],
      allSubArraysEmpty: false,
      loading: false,
      ilLoading: false,
      ilceLoading: false,
      selectedImagesFromServer: [],
      path: projeService.path,
      imagePath: projeService.imagePath,
      belgePath: projeService.belgePath,
      editor: ClassicEditor,
      editorConfig: {
        language: 'tr',
      },
      activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      visibleSil: false,
      disabled: false,
      options: [],
      dateRangeOptions: {
        firstDayOfWeek: 1
      },
      seciliSozlesmeler: [],
      sozlesmeTarihBaslikGoster: false,
      projeForm: {
        musteriAdi: '',
        not: '',
        projeBaslik: '',
        yatirimTutari: '',
        istihdamSayisi: '',
        alan: '',
        ada: '',
        parsel: '',
        musteriID: '',
        ulkeID: '',
        adresBaslik: 'OSB',
        durum: '1',
        tarihler: {
          yonetimTarihi: '',
          tebligatTarihi: '',
          noterTarihi: '',
          arsaTahsisTarihi: '',
          yapiRuhsatTarihi: '',
          isYeriAcmaRuhsatTarihi: '',
        },
      },
      selectIcon: '1',
      page: 0,
      postPage: 0,
      sizes: 10,
      rulesProje: {
        projeBaslik: [{
          required: true,
          message: "Lütfen Proje Adı Giriniz",
          trigger: 'blur'
        }],
        musteriID: [{
          required: true,
          message: "Lütfen Firma Seçiniz",
          trigger: 'blur'
        }],
        alan: [{
          required: true,
          message: "Lütfen Alan Giriniz",
          trigger: 'blur'
        }],
        ada: [{
          required: true,
          message: "Lütfen Ada Giriniz",
          trigger: 'blur'
        }],
        parsel: [{
          required: true,
          message: "Lütfen Parsel Giriniz",
          trigger: 'blur'
        }],
        adresBaslik: [{
          required: true,
          message: "Lütfen Adres Giriniz",
          trigger: 'blur'
        }],
        yatirimTutari: [{
          required: true,
          message: "Lütfen Yatırım Tutarı Giriniz",
          trigger: 'blur'
        }],
        istihdamSayisi: [{
          required: true,
          message: "Lütfen İstihdam Sayısı Giriniz",
          trigger: 'blur'
        }]
      },
      customError: {
        tebligat: false,
        noter: false,
      },
    }
  },
  methods: {
    datePickerOptions(tur) {
      const self = this
      return {
        firstDayOfWeek: 1,
        disabledDate: date => {
          if (tur == 'noter') {
            let noterMinTarih = new Date(self.projeForm.tarihler.tebligatTarihi)
            return date < noterMinTarih
          }
          if (tur == 'arsaTahsis') {
            let arsaMinTarih = new Date(self.projeForm.tarihler.tebligatTarihi)
            return date < arsaMinTarih
          }
          if (tur == 'yapiRuhsat') {
            let yapiMinTarih = new Date(self.projeForm.tarihler.tebligatTarihi)
            return date < yapiMinTarih
          }
          if (tur == 'isYeriAcma') {
            let isYeriAcmaMaxTarih = new Date(moment(this.projeForm.tarihler.yapiRuhsatTarihi).add(730, 'days').format('YYYY-MM-DD'))
            return date < new Date(self.projeForm.tarihler.yapiRuhsatTarihi) || date > isYeriAcmaMaxTarih
          }
        }
      };
    },
    setCustomChange(newVal, tur, border = false) {
      if (tur == 'yonetim') {
        this.projeForm.tarihler.tebligatTarihi = newVal
        let noterVeArsaTarih = moment(newVal).add(15, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.noterTarihi = noterVeArsaTarih
        this.projeForm.tarihler.arsaTahsisTarihi = noterVeArsaTarih
        let yapiRuhsatTarihi = moment(noterVeArsaTarih).add(365, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.yapiRuhsatTarihi = yapiRuhsatTarihi
        let isYeriAcmaTarihi = moment(yapiRuhsatTarihi).add(730, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = isYeriAcmaTarihi
      }
      if (tur == 'tebligat') {
        let noterVeArsaTarih = moment(newVal).add(15, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.noterTarihi = noterVeArsaTarih
        this.projeForm.tarihler.arsaTahsisTarihi = noterVeArsaTarih
        let yapiRuhsatTarihi = moment(noterVeArsaTarih).add(365, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.yapiRuhsatTarihi = yapiRuhsatTarihi
        let isYeriAcmaTarihi = moment(yapiRuhsatTarihi).add(730, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = isYeriAcmaTarihi
      }
      if (tur == 'noter') {
        this.projeForm.tarihler.arsaTahsisTarihi = newVal
        let yapiRuhsatTarihi = moment(newVal).add(365, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.yapiRuhsatTarihi = yapiRuhsatTarihi
        let isYeriAcmaTarihi = moment(yapiRuhsatTarihi).add(730, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = isYeriAcmaTarihi
      }
      if (tur == 'arsaTahsis') {
        let yapiRuhsatTarihi = moment(newVal).add(365, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.yapiRuhsatTarihi = yapiRuhsatTarihi
        let isYeriAcmaTarihi = moment(yapiRuhsatTarihi).add(730, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = isYeriAcmaTarihi
      }
      if (tur == 'yapiRuhsat') {
        let isYeriAcmaTarihi = moment(newVal).add(730, 'days').format('YYYY-MM-DD')
        this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = isYeriAcmaTarihi
      }
      if (border) {
        if (tur == 'yonetim') if (newVal != '') this.customError.tebligat = false
        if (tur == 'tebligat') if (newVal != '') this.customError.tebligat = false
        if (tur == 'noter') if (newVal != '') this.customError.noter = false
      }
    },
    validateParsel() {
      const regex = /^[0-9!@#\$%\^\&*\)\(+=._-]+$/;
      if (!regex.test(this.projeForm.parsel)) {
        this.projeForm.parsel = this.projeForm.parsel.replace(/[^0-9!@#\$%\^\&*/\)\(+=._-]+$/, '');
      }
    },
    formatAlan() {
      this.projeForm.alan = this.projeForm.alan.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    checkDevice() {
      this.isDesktop = window.innerWidth >= 821;
    },
    isSuresi(item, total) {
      let bitis = moment(this.projeForm.baslangicTarihi).add(total, 'days')
      item.isTeslimTarihi = moment(bitis).format('YYYY-MM-DD')
    },
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    },
    refreshPage() {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.stateLoading = false;

      // this.getMusteriSayisi();
      this.getMusteriListesi();
      //this.getUlkeListesi();
      this.getSozlesmeListesi();
      // this.getIlListesi();
    },
    getMusteriListesi() {
      try {
        this.loading = true;
        musteriService.getCustomerListUnlimited(this.selectIcon, this.postPage, 1000).then((response) => {
          localStorage.setItem("userDataDemirag", response.token)
          if (response.status == 200) {
            this.musteriler = response.data;
          }
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.musteriler = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        // notification.Status("success", this, "An error occurred while fetching the customer list.")
        this.loading = false
      }
    },
    projeEkle(formName) {
      if (this.projeForm.tarihler.tebligatTarihi == '') this.customError.tebligat = true
      else this.customError.tebligat = false
      if (this.projeForm.tarihler.noterTarihi == '') this.customError.noter = true
      else this.customError.noter = false
      this.$refs[formName].validate((valid, errors) => {
        if (!this.customError.tebligat && !this.customError.noter) {
          if (valid) {
            this.$confirm("Yatırımı tanımlamak istediğinize emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
              confirmButtonText: this.$t("src.views.apps.genel.yes"),
              cancelButtonText: this.$t("src.views.apps.genel.no"),
              type: 'warning'
            }).then(() => {
              try {
                this.loading = true;
                projeService.projeEkle(this.projeForm).then((response) => {
                  if (response.status == 200) {
                    localStorage.setItem("userDataDemirag", response.token)
                    notification.Status("success", this, response.msg)
                    EventBus.$emit("yatirimListesi", this.projeForm.durum)
                    functions.sayfaKapat("yatirimtanimla", this);
                    this.resetForm(formName)
                  }
                  this.loading = false;
                }).catch(err => {
                  if (err.responseJSON) {
                    let error = err.responseJSON
                    if (error.status == 401) {
                      notification.Status(150, this);
                    } else notification.Status("errorMsg", this, error.errMsg)
                  } else {
                    //notification.Status(503, this)
                  }
                  this.loading = false;
                })
              } catch (e) {
                // console.log(e);
                notification.Status("warning", this, this.$t('Yatırımı Tanımlanırken Bir Hata Meydana Geldi'))
                this.loading = false;
              }
            })
          } else {
            for (var k in errors) {
              errors[k].forEach((element) => {
                notification.Status("warning", this, element.message);
              })
              this.loading = false
            }
          }
        }
      })
    },
    indexMethod(index) {
      return ((this.page - 1) * 10) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getMusteriListesi();
      //this.getUlkeListesi();
      this.getSozlesmeListesi();
    },
    handleChange(event) {
      this.selectIcon = event;
      this.page = 1;
      this.postPage = 0;
      this.getMusteriListesi();
      // this.getUlkeListesi();
      this.getSozlesmeListesi();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      this.getMusteriListesi();
      // this.getUlkeListesi();
      this.getSozlesmeListesi();
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visibleSil = false;
      this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = ''
      this.projeForm.tarihler.yapiRuhsatTarihi = ''
      this.projeForm.tarihler.arsaTahsisTarihi = ''
      this.projeForm.tarihler.tebligatTarihi = ''
      this.projeForm.tarihler.noterTarihi = ''
      this.customError.tebligat = false
      this.customError.noter = false
    },
  }
}

</script>

<style lang="scss" scoped>
@media screen and (min-width: 1200px) {
  .yatirim-tarihler-ust-col {
    @media only screen and (min-width: 1200px) {
      .el-col-lg-3 {
        width: 16.6%;
      }
    }

    .el-col-lg-4 {
      width: 20% !important;
    }
  }
}

.arsa-tarih-card {
  position: relative;
  margin-top: 20px;

  .top-row-line-danger {
    height: 5px;
    background-color: red;
    margin: 0 0 20px 0;
  }

  .top-row-line-space {
    height: 5px;
    background-color: transparent;
    margin: 0 0 20px 0;
  }

  .information-icon {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  .el-card__body {
    padding: 0 0 0 0 !important;

    .el-form-item {
      padding: 20px 10px 8px 10px;
    }

    h4 {
      text-align: center;
      margin: 0;
    }
  }
}
</style>
<style lang="scss">

.sozlesmeSelect {
  .el-row {
    padding: 10px 10px 10px 8px;
  }

  .el-row:nth-child(2n) {
    background: #f3f7fa !important
  }
}
</style>
<style>
.arsa-tarih-card {
  .el-card__body {
    padding: 0 0 0 0 !important;
  }
}

.flex-box {
  display: flex;
  justify-content: flex-end;
}

.kapsamlar .el-collapse-item .el-collapse-item__header {
  color: white;
  text-align: center;
  font-size: 15px !important;
  padding: 0px 10px;
  font-weight: 400;
  border-radius: 8px;
}

.kapsamlar .el-collapse-item:nth-child(1) .el-collapse-item__header {
  background-color: #28323b;
}

.kapsamlar .el-collapse-item:nth-child(2) .el-collapse-item__header {
  background-color: #006cae;
}

.kapsamlar .el-collapse-item:nth-child(3) .el-collapse-item__header {
  background-color: #3595cf;
}

.kapsamlar .el-collapse-item:nth-child(4) .el-collapse-item__header {
  background-color: #ff8b00;
}
</style>
